/** 
 * @type {import("./defs").StorePlan} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StorePlan} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StorePlan.js